module.exports = __webpack_public_path__ + "static/media/8-10.cac0e672.mp3";